import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContactBanner from '../../components/ContactBanner';
import { colors, typography } from '../../styles';

const styles = css`
background: ${colors.color2};
main{@media(max-width: 992px){
  position: relative;
  top: 60px;
}}
  .PrivacyPolicy_content {
    padding: 26px 20px 80px;
    @media (min-width: 768px) {
      padding: 48px 40px 110px;
    }
    @media (min-width: 992px) {
      padding: 57px 90px 130px;
    }
  }
  .PrivacyPolicy_container {
    @media (min-width: 992px) {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .PrivacyPolicy_header {
    font-family: ${typography.Serif};
    font-style: italic;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.151515;
    @media (min-width: 768px) {
      font-size: 28px;
      margin-bottom: 18px;
    }
    @media (min-width: 992px) {
      font-size: 33px;
      margin-bottom: 20px;
    }
  }
  .PrivacyPolicy_leadCopy {
    font-size: 16px;
    line-height: 2.0625;
    color: #484941;
    margin-bottom: 1.5em;
    @media (min-width: 768px) {
      font-size: 20px;
      font-weight: 300;
      line-height: 1.863636;
    }
    @media (min-width: 992px) {
      font-size: 22px;
    }
  }
  .PrivacyPolicy_additionalCopy {
    order: 3;
    font-size: 14px;
    line-height: 2.142857;
    letter-spacing: 0.0375em;
    > * {
      margin-bottom: 1em;
    }
    > :last-child {
      margin-bottom: 0;
    }
    ul, ol {
      line-height: 2;
    }
    li:not(:last-child) {
      margin-bottom: 0.75em;
    }
    @media (min-width: 768px) {
      font-size: 15px;
      line-height: 2;
      ul, ol {
        line-height: 1.866667;
      }
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
`;

function PrivacyPolicy({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <main>
        <section className="PrivacyPolicy_content">
          <div className="row mx-0">
            {
              get(page, 'welcome_section', []).map(item => (
                <div className="PrivacyPolicy_welcomeWrapper" key={item.title}>
                  <h2 className="PrivacyPolicy_header GoldText">{item.title}</h2>
                  <div className="PrivacyPolicy_additionalCopy" dangerouslySetInnerHTML={SanitizeHtml(item.lead_copy)} />
                </div>
              ))
            }
          </div>
          <div className="PrivacyPolicy_container pt-5">
            <h2 className="PrivacyPolicy_header GoldText">{page.page_subtitle}</h2>
            <div
              className="PrivacyPolicy_additionalCopy"
              dangerouslySetInnerHTML={SanitizeHtml(get(page, 'introduction_content_section'))}
            />
          </div>
        </section>
      </main>
      <ContactBanner />
    </PageWrapper>
  );
}

PrivacyPolicy.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'privacy_policy',
})(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/index.js